module.exports = "<div class=\"panel-group\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Accordion.vue
// module id = 93
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Accordion.vue?68d8